import React, { useState } from "react";
import "./changePassword.scss";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import SnackBar from "../../components/snackbar/Snackbar";

import { t } from "i18next";
import { changePasswordWS } from "./api/changePasswordApi";
import { Stack, Form, InputGroup, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { gestioneSnackbar } from "../../utils/common";

const ChangePassword = () => {
  const navigate = useNavigate();

  const [showNewPassword, setShowNewPassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");

  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [oldPassword, setOldPassword] = useState("");

  const togglePasswordVisibility = (setShowPassword, showPassword) => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    changePasswordWS({ oldPassword, newPassword, confirmPassword })
      .then((res) => {
        gestioneSnackbar(true, res.message, "success");
        navigate("/settings");
      })
      .catch((err) => {
        console.log(err);
        gestioneSnackbar(true, err.message, "error");
      });
  };

  return (
    <div className="container-change-password">
      <div className="stack-change-password">
        <Stack gap={3}>
          <div className="header-change-password">
            <div>
              <h2>{t("change_password.title")}</h2>
            </div>
            <div>
              <p>{t("change_password.subtitle")}</p>
            </div>
          </div>

          <Form onSubmit={(e) => handleSubmit(e)}>
            <Form.Group className="mb-3" controlId="formPlaintextPassword">
              <InputGroup>
                <Form.Control
                  className="input-login"
                  type={showOldPassword ? "text" : "password"}
                  placeholder={t("change_password.old_password")}
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                />
                <InputGroup.Text
                  className="input-login"
                  onClick={() => {
                    togglePasswordVisibility(
                      setShowOldPassword,
                      showOldPassword
                    );
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {showNewPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </InputGroup.Text>
              </InputGroup>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formPlaintextPassword">
              <InputGroup>
                <Form.Control
                  className="input-login"
                  type={showNewPassword ? "text" : "password"}
                  placeholder={t("change_password.new_password")}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                <InputGroup.Text
                  className="input-login"
                  onClick={() => {
                    togglePasswordVisibility(
                      setShowNewPassword,
                      showNewPassword
                    );
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {showNewPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </InputGroup.Text>
              </InputGroup>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formPlaintextPassword">
              <InputGroup>
                <Form.Control
                  className="input-login"
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder={t("change_password.confirm_password")}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <InputGroup.Text
                  className="input-login"
                  onClick={() => {
                    togglePasswordVisibility(
                      setShowConfirmPassword,
                      showConfirmPassword
                    );
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {showConfirmPassword ? (
                    <VisibilityOffIcon />
                  ) : (
                    <VisibilityIcon />
                  )}
                </InputGroup.Text>
              </InputGroup>
            </Form.Group>
            <div className="w-100 d-flex justify-content-center">
              <Button
                variant="light"
                size="md"
                type="submit"
                style={{ width: 200 }}
              >
                {t("common.save")}
              </Button>
            </div>
          </Form>
          <div className="link-go-back">
            <Link to="../settings">{t("common.back_to_previous")}</Link>
          </div>
        </Stack>
      </div>
      <SnackBar />
    </div>
  );
};

export default ChangePassword;
